// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `iframe {
  width: 100%;
  height: calc(100vh - 100px);
  border: 0;
}
#pcd_form {
  display: flex !important;
  align-items: center !important;
  height: calc(100vh - 16px) !important;
  flex-direction: column;
  gap: 54px;
  padding: 40px;
  justify-content: center;
}
#pcivault-pcd-other-logo,
#pcivault-pcd-card-logo-back {
  display: none;
}
#pcd_form p {
  width: 75%;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  margin-top: 38px;
}

#pcivault-pcd-card-front-grid {
  background: #052456;
  border-radius: 20px;
}
#pcivault-pcd-form-button-submit {
  background: var(--orange);
  border-radius: 40px;
  position: relative;
  font-size: 16px;
  font-weight: 700;
  line-height: 20.16px;
}
.card-back.svelte-n0l7ks {
  background: var(--indigo);
  border-radius: 20px;
}
#pcivault-pcd-form-cvv-input {
  gap: 12px;
  display: flex;
  flex-direction: column;
}
.two-FA-auth {
  width: 496px;
  border-radius: 20px;
  box-shadow: 0px 10px 25px 0px #0000001a;
  padding: 30px;
}
.two-FA-auth h1 {
  font-size: 24px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}
.two-FA-auth p {
  font-size: 14px;
  font-weight: 500 !important;
  text-align: left;
  margin-top: 20px !important;
}
.two-FA-auth input {
  border: 1px solid #c5c5c7;
  width: 96%;
  height: 48px;
  margin-top: 13px;
  border-radius: 10px;
  padding-left: 16.5px;
  outline: none;
  font-family: "Plus Jakarta Sans", sans-serif !important;
}
.two-FA-auth .btn {
  width: 100%;
  height: 52px;
  border-radius: 100px;
  background: var(--orange);
  outline: none;
  border: none;
  font-size: 16px;
  font-weight: 700;
  line-height: 20.16px;
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.resend-otp {
  font-size: 16px;
  font-weight: 500;
  line-height: 50px;
  text-underline-position: under;
  text-align: center;
  cursor: pointer;
  text-decoration: underline;
  background: none;
  border: none;
}
.limit-reached{
  color: #f77c7c;
}

#pcd_form .error {
  color: var(--validationError);
  margin-top: 4px !important;
}
.two-FA-auth .notification {
  color: #2db683;
  margin-top: 0px !important;
}
#pcd_form .notification {
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/creditCardForm/creditCardForm.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,qCAAqC;EACrC,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,uBAAuB;AACzB;AACA;;EAEE,aAAa;AACf;AACA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,uDAAuD;AACzD;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB","sourcesContent":["iframe {\n  width: 100%;\n  height: calc(100vh - 100px);\n  border: 0;\n}\n#pcd_form {\n  display: flex !important;\n  align-items: center !important;\n  height: calc(100vh - 16px) !important;\n  flex-direction: column;\n  gap: 54px;\n  padding: 40px;\n  justify-content: center;\n}\n#pcivault-pcd-other-logo,\n#pcivault-pcd-card-logo-back {\n  display: none;\n}\n#pcd_form p {\n  width: 75%;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  text-align: left;\n  margin-top: 38px;\n}\n\n#pcivault-pcd-card-front-grid {\n  background: #052456;\n  border-radius: 20px;\n}\n#pcivault-pcd-form-button-submit {\n  background: var(--orange);\n  border-radius: 40px;\n  position: relative;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 20.16px;\n}\n.card-back.svelte-n0l7ks {\n  background: var(--indigo);\n  border-radius: 20px;\n}\n#pcivault-pcd-form-cvv-input {\n  gap: 12px;\n  display: flex;\n  flex-direction: column;\n}\n.two-FA-auth {\n  width: 496px;\n  border-radius: 20px;\n  box-shadow: 0px 10px 25px 0px #0000001a;\n  padding: 30px;\n}\n.two-FA-auth h1 {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 36px;\n  text-align: left;\n}\n.two-FA-auth p {\n  font-size: 14px;\n  font-weight: 500 !important;\n  text-align: left;\n  margin-top: 20px !important;\n}\n.two-FA-auth input {\n  border: 1px solid #c5c5c7;\n  width: 96%;\n  height: 48px;\n  margin-top: 13px;\n  border-radius: 10px;\n  padding-left: 16.5px;\n  outline: none;\n  font-family: \"Plus Jakarta Sans\", sans-serif !important;\n}\n.two-FA-auth .btn {\n  width: 100%;\n  height: 52px;\n  border-radius: 100px;\n  background: var(--orange);\n  outline: none;\n  border: none;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 20.16px;\n  color: var(--white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n}\n.resend-otp {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 50px;\n  text-underline-position: under;\n  text-align: center;\n  cursor: pointer;\n  text-decoration: underline;\n  background: none;\n  border: none;\n}\n.limit-reached{\n  color: #f77c7c;\n}\n\n#pcd_form .error {\n  color: var(--validationError);\n  margin-top: 4px !important;\n}\n.two-FA-auth .notification {\n  color: #2db683;\n  margin-top: 0px !important;\n}\n#pcd_form .notification {\n  width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
